import moment from 'moment';

export const getQuote = state => state.quote;
export const getQuoteUser = state => (state.quote.user ? state.quote.user.data : null);
export const getVehicles = state => state.vehicles;
export const getCurrencies = state => state.currencies;
export const getVehicleInsuranceOptions = state => state.vehicleInsuranceOptions;
export const getExtras = state => state.extras;
export const getTotals = state => (state.quote.totals ? state.quote.totals.data : []);
export const getCustomer = state => state.customer;
export const getLocale = state => state.quote.locale;
export const getSelectedVehicle = state =>
    state.quote.selected_vehicle ? state.quote.selected_vehicle.data.vehicle.data : {};
export const getSelectedVehicleInsuranceOptions = state =>
    state.quote.selected_vehicle && state.quote.selected_vehicle.data.selected_insurance_options
        ? state.quote.selected_vehicle.data.selected_insurance_options.data
        : [];
export const getSelectedVehicleProduct = state =>
    state.quote.selected_vehicle && state.quote.selected_vehicle.data.product
        ? state.quote.selected_vehicle.data.product.data
        : {};
export const getSelectedExtras = state => (state.quote.selected_extras ? state.quote.selected_extras.data : []);
export const getPickupLocation = state => state.quote.pickup_location.data;
export const getDropoffLocation = state => state.quote.dropoff_location.data;
export const getPickupDate = state => state.search.pickupDate;
export const getPickupTime = state => state.search.pickupTime;
export const getDropoffDate = state => state.search.dropoffDate;
export const getDropoffTime = state => state.search.dropoffTime;
export const quoteHireDuration = state => {
    let duration = moment(state.quote.utc_dropoff_datetime).diff(moment(state.quote.utc_pickup_datetime), 'hours');
    return Math.ceil(duration / 24) || 1;
};
export const quotePaymentType = state => state.quote.payment_type;
export const getCreateDirect = state => (window.greenmotion ? window.greenmotion.createDirect : false);
export const selectedCurrency = state => {
    const selectedCurrency = state.currencies.filter(currency => {
        return currency.code == state.currency.code;
    });

    return selectedCurrency.length ? selectedCurrency[0] : state.currency;
};
export const getSavedCards = state => {
    if (!state.quote) {
        return [];
    } else if (!state.quote.user) {
        return [];
    } else if (!state.quote.user.data.cards) {
        return [];
    } else if (!state.quote.user.data.cards.data) {
        return [];
    } else {
        return state.quote.user.data.cards.data.map(item => {
            return {
                id: item.id,
                brand: item.brand,
                number: '**** **** **** ' + item.last4,
                expiry: item.exp_month + '/' + item.exp_year,
            };
        });
    }
};

export const getHasUpgradedVehicle = state => state.hasUpgradedVehicle;
export const getSelectedVehicleType = state => state.selectedVehicleType;



// WEBPACK FOOTER //
// ./resources/scripts/greenmotion-shared/vuex/quotes/getters.js